import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { firebaseApp } from '../firebase';
import { getFirestore, doc, onSnapshot } from 'firebase/firestore';

interface VerificationStatus {
  isVerified: boolean;
  verificationScore?: number;
  verificationDate?: Date;
  loading: boolean;
}

export const useVerificationStatus = (): VerificationStatus => {
  const { user } = useAuth();
  const [verificationStatus, setVerificationStatus] = useState<VerificationStatus>({
    isVerified: false,
    loading: true
  });

  useEffect(() => {
    if (!user) {
      setVerificationStatus({ isVerified: false, loading: false });
      return;
    }

    const db = getFirestore(firebaseApp);
    const profileRef = doc(db, 'userProfiles', user.id);

    const unsubscribe = onSnapshot(profileRef, (doc) => {
      if (doc.exists()) {
        const data = doc.data();
        setVerificationStatus({
          isVerified: data.skillsVerified || false,
          verificationScore: data.verificationScore,
          verificationDate: data.verificationDate?.toDate ? data.verificationDate.toDate() : data.verificationDate,
          loading: false
        });
      } else {
        setVerificationStatus({ isVerified: false, loading: false });
      }
    }, (error) => {
      setVerificationStatus({ isVerified: false, loading: false });
    });

    return () => unsubscribe();
  }, [user]);

  return verificationStatus;
};